<template>
    <div>
        <!--        <breadcrumb :routerList="[{title:'OEM付款报表 '}]"/>-->
        <Breadtabsheader/>
        <div class="h-content" style="">
            <!-- tab切换 -->
            <div class=" ">
                <el-tabs v-model="activeName" type="border-card">
<!--                    <el-tab-pane label="400客服线索" name="first" :key="'first'">
                        <bscClueManage v-if="isFirst" />
                    </el-tab-pane>-->

                    <el-tab-pane label="新营销" name="fourth" :key="'fourth'">
                        <bscClueZhaoBiaoList :fromSourceList="fromSourceMC" :fromSourceType="'fourth'" v-if="activeName === 'fourth'" />
                    </el-tab-pane>
                    <el-tab-pane label="实时招标" name="second" :key="'second'">
                        <bscClueZhaoBiaoList :fromSourceList="fromSourceRTB" :fromSourceType="'second'" v-if="activeName === 'second'" />
                    </el-tab-pane>
                    <el-tab-pane label="设计院(七类机会)" name="third" :key="'third'">
                        <bscClueZhaoBiaoList :fromSourceList="fromSourcePP" :fromSourceType="'third'" v-if="activeName === 'third'" />
                    </el-tab-pane>
                    <el-tab-pane label="新渠道(政府商城)" name="fifth" :key="'fifth'">
                        <bscClueZhaoBiaoList  :fromSourceList="fromSourceCH" :fromSourceType="'fifth'" v-if="activeName === 'fifth'" />
                    </el-tab-pane>


                </el-tabs>
            </div>
        </div>
    </div>
</template>
<script>
import bscClueManage from '../bsccluemanage/bscClueManage.vue'
import bscClueZhaoBiaoList from './bscClueZhaoBiaoList.vue'
export default {
    components: {
        //Breadcrumb,
        bscClueManage,bscClueZhaoBiaoList
    },
    data() {
        return {
            // 默认第一个Tab
            activeName: "fourth",

            fromSourceMC:["MC_03"],
            fromSourceRTB:["RTB_91","RTB_93"],
            fromSourcePP:["PP_01","PP_02"],
            fromSourceCH: ["CH_01"],

        };

    },
    created() {
        if(this.$route.query.type){
            this.activeName = this.$route.query.type;
        }

    },
    methods: {
        //tab切换
        handleClick(tab) {




        },

    }
}
</script>
<style scoped>
.h-content{
    background: #fff
}
</style>
